const sanitizeByMetadata = (data = {}, paramsMeta = {}, extraAllowed = []) => {
  const allowed = new Set([...Object.keys(paramsMeta || {}), ...extraAllowed]);
  return Object.fromEntries(Object.entries(data || {}).filter(([k]) => allowed.has(k)));
};

export default sanitizeByMetadata;
